module.exports = __webpack_public_path__ + "img/swp1.96dc8f19.png";